import { useQuestionScreen } from '../contexts/question-screen-context';
import { useMultiSelectWithPrimaryQuestion } from '../hooks/use-multi-select-with-primary-question';
import { QuestionBodyMultiSelectWithPrimary } from './question-body-multi-select-with-primary';
import { QuestionScreenLayout } from './question-screen-layout';

export function MultiSelectWithPrimaryScreen() {
  const { question, resolved, answers, isSubmitting, submitAnswer } = useQuestionScreen();

  const initialPrimary = (answers.primary_goal as string | undefined) ?? null;
  const initialSecondary = (answers.secondary_goals as string[] | undefined) ?? [];
  const initialPrimaryOtherText = answers.primary_goal_other_text ?? '';
  const initialSecondaryOtherText = answers.secondary_goals_other_text ?? '';

  const {
    primary,
    setPrimary,
    secondary,
    setSecondary,
    primaryOtherText,
    setPrimaryOtherText,
    secondaryOtherText,
    setSecondaryOtherText,
    isValid,
    submit,
  } = useMultiSelectWithPrimaryQuestion({
    question,
    initialPrimary,
    initialSecondary,
    initialPrimaryOtherText,
    initialSecondaryOtherText,
    onSubmit: submitAnswer,
  });

  return (
    <QuestionScreenLayout
      onNext={submit}
      nextDisabled={!isValid}
    >
      <QuestionBodyMultiSelectWithPrimary
        options={resolved.options}
        primaryValue={primary}
        secondaryValues={secondary}
        primaryOtherText={primaryOtherText}
        secondaryOtherText={secondaryOtherText}
        onPrimaryChange={setPrimary}
        onSecondaryChange={setSecondary}
        onPrimaryOtherTextChange={setPrimaryOtherText}
        onSecondaryOtherTextChange={setSecondaryOtherText}
        disabled={isSubmitting}
      />
    </QuestionScreenLayout>
  );
}
